export const publicPages = [
  { path: "/community", title: "Community — Proxima Forma", description: "Explore featured Proxima Forma designs and submit your project to be considered for a public feature." },
  { path: "/blog", title: "Blog — Proxima Forma", description: "Product announcements, design ideas, and guides to working with your agents on a shared canvas." },
  { path: "/blog/shared-design-canvas", title: "Meet your shared design canvas — Proxima Forma", description: "Shape ideas with your agents, refine editable elements, and review designs together in Proxima Forma." },
  { path: "/blog/bring-your-agent", title: "Bring the agent you already use — Proxima Forma", description: "Connect your existing agent to an editable design canvas with guided setup for ChatGPT, Claude Code, and custom agents." },
  { path: "/connect/claude", title: "Design with Claude — Proxima Forma", description: "Connect Proxima Forma as a remote MCP connector and design directly through Claude." },
  { path: "/connect/agent", title: "Custom connectors — Proxima Forma", description: "Bring any remote MCP-compatible agent or client into the Proxima Forma design workspace." },
  { path: "/terms", title: "Terms of service — ProximaForma", description: "Terms for using the ProximaForma hosted workspace, AI features, and agent connections." },
  { path: "/impressum", title: "Impressum — Proxima Forma", description: "Legal notice and provider information for Proxima Forma." },
  { path: "/support", title: "Support — ProximaForma", description: "Contact ProximaForma for account, connection, billing, and privacy support." },
  {
    path: "/connect/chatgpt",
    title: "Design with ChatGPT — Proxima Forma",
    description: "Add Proxima Forma as a custom ChatGPT app, review its MCP tools, and design from your conversation.",
  },
  {
    path: "/",
    title: "Proxima Forma — Design at the speed of AI",
    description:
      "Your creative direction, agents do the work. Design with ChatGPT, Claude, or your custom agent on one shared, editable canvas.",
  },
  {
    path: "/product",
    title: "The product — Proximaforma",
    description:
      "Private canvases, page navigation, shared feedback, live agent edits, and portable exports.",
  },
  {
    path: "/use-cases",
    title: "Ways to work — Proximaforma",
    description:
      "Explore interface concepts, refine product screens, and build repeatable design workflows with your AI agents.",
  },
  {
    path: "/integrations",
    title: "Bring your agents — Proximaforma",
    description:
      "Connect your tools to the design canvas with MCP over stdio or Streamable HTTP, or build directly with the REST API.",
  },
  {
    path: "/pricing",
    title: "Pricing — Proxima Forma",
    description:
      "Pay as you go with free registration credit and top-ups from €5. No monthly subscription or recurring plan.",
  },
  {
    path: "/docs",
    title: "Getting started — Proximaforma docs",
    description:
      "Run Proximaforma locally, make your first design, and connect an AI agent to the same workspace.",
  },
  {
    path: "/docs/mcp",
    title: "MCP setup and tools — Proximaforma docs",
    description:
      "Connect a local MCP client, configure Streamable HTTP, and use Proximaforma’s design and comment tools.",
  },
  {
    path: "/docs/api",
    title: "REST API reference — Proximaforma docs",
    description:
      "Create projects, add design elements, send atomic batches, handle revision conflicts, and export your work through the REST API.",
  },
  {
    path: "/docs/workspace",
    title: "Canvas guide — Proximaforma docs",
    description:
      "Learn frames, layers, keyboard shortcuts, precise editing, preview, and exports in the Proximaforma workspace.",
  },
  {
    path: "/changelog",
    title: "What’s new — Proximaforma",
    description:
      "Release notes for Proximaforma, including the local canvas, agent connections, and marketing pages.",
  },
  {
    path: "/privacy",
    title: "Your data — Proximaforma",
    description:
      "How ProximaForma stores account and design data, connects AI services, and handles privacy requests.",
  },
] as const;

export function normalizePath(path: string) {
  return path.replace(/\/+$/, "") || "/";
}

export function pageMetadata(path: string) {
  const normalized = normalizePath(path);
  return (
    publicPages.find((page) => page.path === normalized) ?? {
      path: normalized,
      title:
        normalized === "/app"
          ? "Workspace — Proximaforma"
          : "Page not found — Proximaforma",
      description:
        normalized === "/app"
          ? "Your shared design workspace for people and AI agents."
          : "Find your way back to Proximaforma’s product, documentation, or design workspace.",
    }
  );
}
